var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKarunaWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 271.8 102.2",
    style: {
      enableBackground: "new 0 0 271.8 102.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD200;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "karuna_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "karuna"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.6,40.7h-5.7l-8.9,8.7V31.6h-4.5v32h4.5V55l2.8-2.7l8.4,11.3h5l-10.3-14.1L148.6,40.7z M160.3,40.4 c-6.4-0.1-11.9,5.4-11.8,11.8c-0.1,6.4,5.4,11.9,11.8,11.8c3.2,0,6.2-1.7,7.3-4v3.6h4.5V52.2C172.2,45.8,166.7,40.2,160.3,40.4z  M160.4,59.6c-4.1,0-7.4-3.3-7.4-7.5s3.2-7.5,7.4-7.5c4.2,0,7.3,3.3,7.3,7.5S164.5,59.6,160.4,59.6z M175.3,51.7v11.9h4.5V51.7 c0-4.5,1.8-6.7,5.1-6.7h0.5v-4.3h-0.5C179,40.6,175.3,44.3,175.3,51.7z M203.7,52.8c0,4.6-2,6.9-5.6,6.9c-3.6,0-5.6-2.3-5.6-6.9 v-12h-4.5v12c0,7.5,4,11.2,10.1,11.2c6.1,0,10.1-3.7,10.1-11.2v-12h-4.5L203.7,52.8L203.7,52.8z M221.4,40.4 c-6.1,0-10.1,3.7-10.1,11.2v12h4.5v-12c0-4.6,2-6.9,5.6-6.9s5.6,2.3,5.6,6.9v12h4.5v-12C231.5,44.1,227.5,40.4,221.4,40.4z  M245.8,40.4c-6.4-0.1-11.9,5.4-11.8,11.8c-0.1,6.4,5.4,11.9,11.8,11.8c3.2,0,6.2-1.7,7.3-4v3.6h4.5V52.2 C257.7,45.8,252.1,40.2,245.8,40.4z M245.8,59.6c-4.1,0-7.4-3.3-7.4-7.5s3.2-7.5,7.4-7.5c4.2,0,7.3,3.3,7.3,7.5 S249.9,59.6,245.8,59.6z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_8_copy_2_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_8_copy_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.9,51.9l17-16.7c4.4-4.4,4.4-11.5,0-15.8c-4.4-4.4-11.5-4.4-15.8,0l-25,24.5c-2.2,2.2-3.3,5.1-3.3,8 c0,2.9,1.1,5.8,3.3,8l25,24.5c4.4,4.4,11.5,4.4,15.8,0c4.4-4.4,4.4-11.5,0-15.8L83.9,51.9z M32.8,16.3c-6.2,0-11.2,5-11.2,11.2 v48.9c0,6.2,5,11.2,11.2,11.2S44,82.6,44,76.4V27.5C44,21.3,39,16.3,32.8,16.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarunaWhitecolor);
export default __webpack_public_path__ + "static/media/karuna_white+color.44dc652c01a82432831e91c451f5b1bf.svg";
export { ForwardRef as ReactComponent };